import angular from 'angular'

import { VD_CLASSES } from '../../constants'
import template from './vd-dialog.html'

const DIALOG_CONTAINER = 'vd-dialog-container'

/**
 * A dialog window, usually invoked via the `Modal` service, or with one of its extension like `Confirm`.
 *
 * See `Confirm` service for an example.
 *
 * @param {string} header The dialog header
 *
 * @param {function} close The method to invoke on close
 *
 * @param {html} transclusion The content of the dialog.  `.vd-dialog-content` element is required which should house
 *                            the main content of the dialog.
 *
 */

angular.module('vend.ui').directive('vdDialog', function ($document) {
  return {
    transclude: true,
    scope: {
      header: '@header',
      close: '=close',
      size: '=',
      dismissible: '=',
    },
    template,
    link: {
      pre: (scope, iElement, iAttrs, controller, transcludeFn) => {
        const dialogContainerElement = angular.element(
          iElement[0].querySelector(`.${DIALOG_CONTAINER}`)
        )

        iElement.addClass('vd-dialog')
        transcludeFn(transcludeEl =>
          dialogContainerElement.append(transcludeEl)
        )
      },
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller($scope) {
      // Add and remove class to body for preventing scrolling when modal is open
      const bodyNode = $document.find('body')

      bodyNode.addClass(VD_CLASSES.noBodyScroll)

      /**
       * Allows a modifier to be dynamically set for the child dialog container element. Defaults to medium if not
       * size is not set.
       *
       * @method setDialogContainerModifier
       */
      this.setDialogContainerModifier = function () {
        let dialogContainerModifier = `${DIALOG_CONTAINER}--size-medium`

        if (this.size) {
          dialogContainerModifier = `${DIALOG_CONTAINER}--size-${this.size}`
        }

        return dialogContainerModifier
      }

      $scope.$on('$destroy', () => {
        bodyNode.removeClass(VD_CLASSES.noBodyScroll)
      })
    },
  }
})
